export const getConfirmPopupBasic = (i18n) => ({
  message: i18n.t("message.confirmDialog.message"),
  icon: "pi pi-exclamation-triangle",
});
